<template>
    <div>
        <notifications position="top right" classes="custom-notification"/>
    </div>
</template>

<script>
    import store from '../CartStore'
    export default {
        store: store,
        methods: {
            ...Vuex.mapActions(['deleteProduct', 'updateProduct']),
        }
    }
</script>
